import { cn } from '@worldcoo/ui/lib/utils';
import { WorldcooLogoIcon } from '@worldcoo/ui/custom/worldcoo-logo-icon';

/**
 * The dark CTA band and the strip under it. Darker than `ink` on purpose: the watermark below is the
 * site's own #25302C and the surface recedes around it, not the other way round. Both surfaces take
 * it or they meet on a seam; the `ink` token itself is unchanged.
 */
export const CTA_SURFACE = 'bg-[#1c2824]';

/**
 * The Worldcoo mark behind the CTA band. Far larger than the band — you see a stroke passing behind,
 * not a logo — and sized off its WIDTH, the only dimension stable across the two variants (the
 * two-button band is ~420px tall, the form one ~1050).
 */
export function CtaWatermark(props: { side: 'left' | 'right' }) {
	// The fade is on the mark's own box, not the band's: a gradient's stops map to whatever box carries
	// it, and a band-sized mask put the form variant's mark entirely in its transparent end.
	const fade = 'new-watermark-fade text-ink absolute h-auto';

	return (
		<div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
			{props.side === 'right' ? (
				<WorldcooLogoIcon className={cn(fade, '-right-[6%] bottom-0 w-[85%] max-w-[1000px]')} />
			) : (
				// Bound to the content box, not the section: the form sits in the right column, and a
				// section-relative mark drifts under it as the viewport grows.
				<div className="relative mx-auto h-full max-w-[1440px]">
					<WorldcooLogoIcon className={cn(fade, 'top-1/2 left-0 w-[calc(50%-2.5rem)] -translate-y-1/2')} />
				</div>
			)}
		</div>
	);
}
